import "../PoweredByReeloFooter/PoweredByReeloFooter.scss";

import React from "react";
import { useSelector } from "react-redux";
import isEmpty from "../../../../../../utils/constants/isEmpty";
import {
  thirdPartylinks,
  redirectToDifferentPage,
} from "../../../../../../utils/constants/constants";

const PoweredByReeloFooter = ({ activeStep }) => {
  const initData = useSelector((state) => state?.shortLink?.initData);
  const shortLinkType = initData?.type;

  return (
    <div className="powered-by-footer">
      <h5>Powered By</h5>
      <img
        alt="logo"
        className="reelologo"
        src="/reelo_1x_logo_new.svg"
        onClick={() =>
          redirectToDifferentPage(
            `https://www.reelo.io/?utm_source=shortlink&utm_medium=${
              shortLinkType === "loyalty_redemption" ||
              shortLinkType === "loyalty_test" ||
              shortLinkType === "loyalty"
                ? "loyalty"
                : shortLinkType
            }`
          )
        }
      />
      {(shortLinkType === "loyalty_redemption" ||
        shortLinkType === "loyalty_test" ||
        shortLinkType === "loyalty") && (
        <h4>
          Get{" "}
          <a
            target="_blank"
            rel="noreferrer"
            href="https://www.reelo.io/loyalty"
          >
            loyalty program
          </a>{" "}
          for your business
        </h4>
      )}
      {shortLinkType === "feedback" && (
        <>
          {initData?.feedback?.data?.score <= 3 ? (
            <></>
          ) : activeStep === 3 ||
            (activeStep === 0 && isEmpty(initData?.feedback?.data)) ? (
            <h4>
              Get{" "}
              <a
                target="_blank"
                rel="noreferrer"
                href="https://www.reelo.io/loyalty"
              >
                loyalty program
              </a>{" "}
              for your business
            </h4>
          ) : (
            <h4>
              Collect{" "}
              <a target="_blank" rel="noreferrer" href="https://www.reelo.io">
                feedback
              </a>{" "}
              for your business
            </h4>
          )}
        </>
      )}
      {shortLinkType === "campaign" && (
        <h4>
          Send{" "}
          <a
            target="_blank"
            rel="noreferrer"
            href="https://www.reelo.io/campaigns"
          >
            campaigns
          </a>{" "}
          for your business.
        </h4>
      )}
      <div className="social-icons">
        <a target="_blank" rel="noreferrer" href={thirdPartylinks.insta}>
          <img src="/assets/icons/social-icons/insta-new.svg" alt="insta" />
        </a>
        <a target="_blank" rel="noreferrer" href={thirdPartylinks.fb}>
          <img src="/assets/icons/social-icons/fb-new.svg" alt="fb" />
        </a>
        <a target="_blank" rel="noreferrer" href={thirdPartylinks.twitter}>
          <img src="/assets/icons/social-icons/twitter-new.svg" alt="twitter" />
        </a>
        <a target="_blank" rel="noreferrer" href={thirdPartylinks.linkedin}>
          <img src="/assets/icons/social-icons/linkedIn.svg" alt="linkedin" />
        </a>
        <a target="_blank" rel="noreferrer" href={thirdPartylinks.youtube}>
          <img src="/assets/icons/social-icons/youtube.svg" alt="youtube" />
        </a>
      </div>
    </div>
  );
};

export default PoweredByReeloFooter;
